"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hdWalletPath = void 0;
exports.hdWalletPath = {
    bitcoin: {
        p2pkh: "m/44'/0'/0'",
        p2wpkh: "m/84'/0'/0'",
        "p2sh-p2wpkh": "m/49'/0'/0'",
        p2sh: "m/80'/0'/0'",
        p2wsh: "m/85'/0'/0'",
        "p2sh-p2wsh": "m/90'/0'/0'",
        p2tr: "m/84'/0'/0'",
    },
    ethereum: "m/44'/60'/0'",
};
//# sourceMappingURL=hd-wallet-path.js.map